import { render, staticRenderFns } from "./OccupationalPatientConsultNote.vue?vue&type=template&id=39705dea&"
import script from "./OccupationalPatientConsultNote.vue?vue&type=script&lang=js&"
export * from "./OccupationalPatientConsultNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports